import React from 'react';
import {connect} from 'react-redux';
import {CREATENOTIFICATION, VIEWNOTIFICATION} from 'constants/index';
import './styles.scss';
import CreateNotification from 'components/CreateNotification';
import ViewNotifications from 'components/ViewNotifications';

const notificationFilters = [VIEWNOTIFICATION, CREATENOTIFICATION];

class Notification extends React.Component {
	constructor() {
		super();

		this.state = {
			activeFilter: VIEWNOTIFICATION,
		};
	}

	render() {
		const {activeFilter} = this.state;

		return (
			<div>
				<div className="lit-test-section-drop-down">
					<div className="lit-dropdown_filter">
						<select
							className="lit-input__field"
							defaultValue={VIEWNOTIFICATION}
							onChange={(e) => {
								this.setState({
									activeFilter: notificationFilters.filter(
										(filter) => filter.id === e.target.value
									)[0],
								});
							}}
						>
							{notificationFilters.map((userStageFilter) => (
								<option
									key={userStageFilter.id}
									value={userStageFilter.id}
								>
									{userStageFilter.label ||
										userStageFilter.text}
								</option>
							))}
						</select>
					</div>
				</div>

				{activeFilter === VIEWNOTIFICATION && (
					<div className="notification-list-control-panel">
						<ViewNotifications />
					</div>
				)}
				{activeFilter === CREATENOTIFICATION && (
					<div className="lit-search-by-test-key">
						<CreateNotification />
					</div>
				)}
			</div>
		);
	}
}

const mapStateToProps = () => {
	return {};
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Notification);
